import styled from "styled-components";

export const AvatarContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.avatar-small {
    height: 28px;
    width: 28px;
    aspect-ratio: 1;
  }

  &.avatar-medium {
    height: 48px;
    width: 48px;
    aspect-ratio: 1;
  }

  &.avatar-large {
    width: 99px;
    height: 99px;
    aspect-ratio: 1;
  }

  img {
    border-radius: 50%;
    height: 100%;
    width: 100%;
    aspect-ratio: 1;
  }

  label {
    position: absolute;
    border: 1px solid ${({ theme }) => theme.global.color.quinary};
    background-color: ${({ theme }) => theme.global.bg.quaternary};
    border-radius: 50%;
    font-size: 10px;
    cursor: pointer;
    bottom: 4px;
    right: 5px;
    img {
      padding: 4px;
    }
  }
`;
